import { FC } from 'react';

import { ConfirmModal } from '@/entities/modal';

import {
  MobileDentalPhotoUploadMenu,
  UploadDentalPhotosModal,
} from '@/features/uploadDentalPhotos';

import { AboutLabelingModal } from '@/widgets/AboutLabelingModal';
import { CongratsModal } from '@/widgets/CongratsModal';
import { GetFullAccessModal } from '@/widgets/GetFullAccessModal';
import { MobileOrderReportModal } from '@/widgets/MobileOrderReportModal';
import { OrderReportModal } from '@/widgets/OrderReportModal';
import { PatientModalForm } from '@/widgets/PatientModalForm';
import { RawMeshViewerInfoModal } from '@/widgets/RawMeshViewerInfoModal';
import { ReportInfoModal } from '@/widgets/ReportInfoModal';

type PatientProfileModalsProps = {
  patientID: string;
};

export const PatientProfileModals: FC<PatientProfileModalsProps> = ({
  patientID,
}) => (
  <>
    <PatientModalForm />
    <OrderReportModal />
    <MobileOrderReportModal />
    <MobileDentalPhotoUploadMenu />
    {patientID && <UploadDentalPhotosModal patientID={patientID} />}
    <ConfirmModal />
    <ReportInfoModal />
    <RawMeshViewerInfoModal />
    <AboutLabelingModal />
    <GetFullAccessModal />
    <CongratsModal />
  </>
);
